import RibbonButton, { RibbonButtonState } from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { toggleSuperscript } from 'roosterjs-editor-api';

const superscript: RibbonButton = {
    key: 'superscript',
    title: () => strings.superscript,
    imageSrc: require('../svg/superscript.svg'),
    buttonState: formatState =>
        formatState.isSuperscript ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleSuperscript(plugin.getEditor()),
};

export default superscript;
